const t = (key, label) => ({ key, label, type: 'text' });
const ta = (key, label) => ({ key, label, type: 'textarea' });
const img = (key, label) => ({ key, label, type: 'image' });

const steps = (prefix, label) =>
  [1, 2, 3, 4].flatMap((n) => [t(`${prefix}_${n}_title`, `${label} ${n} · título`), ta(`${prefix}_${n}_text`, `${label} ${n} · texto`)]);

export const CONFIG_GROUPS = [
  { id: 'general', label: 'General' },
  { id: 'home', label: 'Inicio' },
  { id: 'pages', label: 'Catálogo y Personaliza' },
  { id: 'about', label: 'Sobre mí' },
  { id: 'gallery', label: 'Galería' },
  { id: 'business', label: 'Pagos, legal y analítica' }
];

export const CONFIG_SECTIONS = [
  { group: 'general', title: 'Marca y Logo', fields: [t('brand_name', 'Nombre de la marca'), img('logo_url', 'Logo')] },
  { group: 'general', title: 'Cinta animada (una frase por línea)', fields: [ta('marquee_items', 'Frases de la cinta')] },
  {
    group: 'general',
    title: 'Contacto y redes',
    fields: [
      t('contact_email', 'Email'), t('contact_phone', 'Teléfono'), t('contact_address', 'Dirección'),
      t('whatsapp_number', 'Número WhatsApp (sin espacios, con código país)'),
      t('social_instagram', 'Instagram URL'), t('social_facebook', 'Facebook URL'), t('social_twitter', 'Twitter URL')
    ]
  },
  { group: 'general', title: 'Footer', fields: [ta('footer_description', 'Descripción del footer')] },
  {
    group: 'home',
    title: 'Portada (Hero)',
    fields: [
      t('hero_badge', 'Etiqueta superior'), t('hero_line_1', 'Título · línea 1'), t('hero_line_2', 'Título · línea 2'),
      t('hero_line_3', 'Título · línea 3 (azul)'), ta('hero_text', 'Texto'), t('hero_btn_1', 'Botón 1 (catálogo)'),
      t('hero_btn_2', 'Botón 2 (idea)'), img('hero_photo_1', 'Foto grande'), img('hero_photo_2', 'Foto pequeña'),
      t('hero_stat_value', 'Dato destacado (ej: 100%)'), t('hero_stat_label', 'Texto del dato')
    ]
  },
  { group: 'home', title: 'Productos destacados', fields: [t('featured_label', 'Etiqueta'), t('featured_title', 'Título')] },
  {
    group: 'home',
    title: 'Fabricación a medida + 4 pasos',
    fields: [t('made_label', 'Etiqueta'), t('made_title', 'Título'), ta('made_text', 'Texto'), t('made_btn', 'Botón'), ...steps('step', 'Paso')]
  },
  {
    group: 'home',
    title: 'Sobre Kreeo',
    fields: [t('home_about_label', 'Etiqueta'), t('home_about_title', 'Título'), ta('home_about_text', 'Texto'), img('home_about_image', 'Foto'), t('home_about_btn', 'Botón')]
  },
  { group: 'home', title: 'Trabajos recientes (usa las fotos de la Galería)', fields: [t('home_gallery_label', 'Etiqueta'), t('home_gallery_title', 'Título')] },
  { group: 'home', title: 'Llamada final', fields: [t('final_cta_title', 'Título'), t('final_cta_btn', 'Botón')] },
  { group: 'pages', title: 'Página Catálogo', fields: [t('catalog_label', 'Etiqueta'), t('catalog_title', 'Título'), ta('catalog_text', 'Texto')] },
  { group: 'pages', title: 'Página Personaliza tu idea', fields: [t('custom_label', 'Etiqueta'), t('custom_title', 'Título'), ta('custom_text', 'Texto')] },
  {
    group: 'about',
    title: 'Presentación',
    fields: [
      t('me_label', 'Etiqueta'), t('me_title', 'Título'), img('me_photo', 'Tu foto'),
      t('me_intro_title', 'Título presentación'), ta('me_intro_text', 'Texto presentación'),
      t('me_origin_title', 'Título "Cómo nació"'), ta('me_origin_text', 'Texto "Cómo nació"')
    ]
  },
  {
    group: 'about',
    title: 'El taller',
    fields: [
      t('me_workshop_label', 'Etiqueta'), t('me_workshop_title', 'Título taller'), ta('me_workshop_text', 'Texto taller'), img('me_workshop_image', 'Foto taller'),
      t('me_design_title', 'Título diseño'), ta('me_design_text', 'Texto diseño'), img('me_design_image', 'Foto diseño')
    ]
  },
  { group: 'about', title: 'El proceso', fields: [t('me_process_label', 'Etiqueta'), t('me_process_title', 'Título'), ...steps('me_step', 'Paso'), t('me_cta_btn', 'Botón final')] },
  { group: 'gallery', title: 'Textos de la Galería', fields: [t('gallery_label', 'Etiqueta'), t('gallery_title', 'Título'), ta('gallery_text', 'Texto')] },
  {
    group: 'business',
    title: 'Portes y Métodos de Pago',
    fields: [
      t('free_shipping_threshold', 'Envío gratis a partir de (€)'), t('shipping_cost', 'Coste de portes (€)'),
      t('bank_holder', 'Titular de la cuenta bancaria'), t('bank_iban', 'IBAN (para transferencias)'),
      t('paypal_email', 'Email de PayPal (dejar vacío para desactivar PayPal)'),
      t('paypal_me_link', 'Enlace PayPal.me (opcional)'), t('admin_notification_email', 'Email para recibir notificaciones')
    ]
  },
  {
    group: 'business',
    title: 'Datos Legales (Titularidad)',
    fields: [
      t('legal_business_name', 'Denominación comercial'), t('legal_owner_name', 'Nombre / Razón social del titular'),
      t('legal_nif', 'NIF / CIF / DNI'), t('legal_address', 'Domicilio completo'), t('legal_email', 'Email legal (para RGPD)'),
      t('legal_phone', 'Teléfono legal'), t('legal_registry', 'Datos registrales (opcional)')
    ]
  },
  {
    group: 'business',
    title: 'Analítica Web',
    fields: [
      t('ga4_measurement_id', 'Google Analytics 4 ID (formato G-XXXXXXX)'), t('plausible_domain', 'Dominio Plausible (ej: kreeo.es)'),
      { key: 'cookie_banner_enabled', label: 'Mostrar banner de cookies (recomendado si usas GA4)', type: 'checkbox' }
    ]
  }
];
